import styled from 'styled-components';

const GAClickEventTracker = styled.span``;

export default GAClickEventTracker;
